import React from 'react'

import Header from '../HEADER/Header'
import About from '../About/About'
import CompanyLogos from '../Companies/Companies'
import FintechRocketSection from '../FintechSection/FintechSection'
import ServicesGrid from '../ServiceGrid/ServiceGrid'
import Testimonials from '../Testimonial/Testimonial'
import Footer from '../FOOTER/Footer'

const main = () => {
  return (
    <div className='relative w-[100vw] h-screen overflow-y-scroll'>
      <Header />
      <About />
      <CompanyLogos />
      <FintechRocketSection />
      <ServicesGrid />

      <Testimonials />
      <Footer/>
    </div>
  )
}

export default main
